module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-BoldItalic-5277c055d663ea41734370ddfbe67de4.woff";